import { gql } from '@apollo/client'

import { PrivacyNoticeFragment } from '@/fragments'

export default gql`
  query consumerNetworkNotices($promocode: String!, $region_id: Int) {
    consumerNetworkNotices(promocode: $promocode, region_id: $region_id) {
      ...privacy_notice
    }
  }
  ${PrivacyNoticeFragment}
`
